import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "wasChanged", "id", "value", "onChange"];
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
import ScormAdvancedSettingsModal from 'screens/ScormAdvancedSettingsModal';
import Button from 'components/Button';
function ScormSettingsField(_ref) {
  var isDisabled = _ref.isDisabled,
    wasChanged = _ref.wasChanged,
    id = _ref.id,
    value = _ref.value,
    onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAdvancedSettingsModal = _useState2[0],
    setShowAdvancedSettingsModal = _useState2[1];
  return /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('form_scorm_settings'),
    labelId: uniqueId
  }, otherProps), /*#__PURE__*/React.createElement(Button, {
    isDisabled: isDisabled,
    size: "medium",
    variant: "transparent",
    onClick: function onClick() {
      return setShowAdvancedSettingsModal(true);
    },
    ml: "-xs",
    "aria-describedby": t('actions_edit_scorm_settings')
  }, t('actions_edit')), showAdvancedSettingsModal && /*#__PURE__*/React.createElement(ScormAdvancedSettingsModal, {
    onChange: onChange,
    defaultSettings: value,
    onClose: function onClose() {
      return setShowAdvancedSettingsModal(false);
    },
    onSave: function onSave() {
      return setShowAdvancedSettingsModal(false);
    },
    isButtonDisabled: !wasChanged
  }));
}
export default ScormSettingsField;